(ns app.front.view.group.admin.form-pdf-config
  (:require [app.domain.file.model :as file-model]
            [app.front.entities :as entities]
            [app.front.file.upload :as upload]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.files :as files]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.comm :as comm]
            [core.front.event :refer [<sub >evt]]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))



(defn- add-form-image [group-id file-id filename content-type md5]
  (comm/send-command-execution
    {:command    :file/add-group-file
     :data       {:group-id          group-id
                  :file-id           file-id
                  :file/filename     (str md5 "." (-> (str/split filename #"\.")
                                                      last))
                  :file/content-type content-type
                  :file/category     :file.category/form-image
                  :file/md5          md5}
     :on-success [::form-image-uploaded group-id]}))


(rf/reg-event-fx
  ::form-image-uploaded
  (fn [_ [_ group-id status response]]
    (let [file-id (ffirst response)]
      {:dispatch     [::entities/merge-entity-db status response]
       :comm/command {:command    :group/set-group-attribute
                      :data       {:group-id group-id
                                   :key      :group/form-pdf-header-image
                                   :file-id  file-id}
                      :on-success [::attribute-set-successfully]}})))


(rf/reg-event-fx
  ::set-form-header-text
  (fn [_ [_ group-id new-text]]
    {:comm/command {:command    :group/set-group-attribute
                    :data       {:group-id group-id
                                 :key      :group/pdf-header-text
                                 :value    new-text}
                    :on-success [::attribute-set-successfully]}}))


(rf/reg-event-fx
  ::attribute-set-successfully
  (fn [_ [_ status response]]
    {:dispatch-n [[:notifications/add :toast :success :success ""]
                  [::entities/merge-entity-db status response]]}))


(defn form-header-text [tr group]
  (r/with-let [value (r/atom (:group/pdf-header-text group))]
    [:div.bx--col-xs-12.bx--col-md-6
     [:h3 (tr [:group-admin/form-pdf-header-title])]
     [ui-rt/editor-legacy {:initial-value (or @value "")
                           :id            "muni-header-text"
                           :on-change     #(reset! value %)}]
     [:div.flex.justify-end.mt-3
      (cc/button {:kind     :tertiary
                  :disabled (= @value (:group/pdf-header-text group))
                  :on-click #(reset! value (:group/pdf-header-text group))}
                 (tr [:cancel]))
      (cc/button {:kind     :primary
                  :disabled (= @value (:group/pdf-header-text group))
                  :on-click #(>evt [::set-form-header-text (:db/id group) @value])}
                 (tr [:save]))]]))


(defn form-pdf-config [group-id]
  (let [tr    (<sub [:tr])
        group (<sub [::entities/entity group-id])
        image (-> group :group/form-pdf-header-image)]
    [acommon/config-section
     (tr [:group-admin/form-pdf-title])
     (tr [:group-admin/form-pdf-instruction])
     [:div.bx--row
      [:div.bx--col-xs-12.bx--col-md-6
       [:h3 (tr [:group-admin/form-pdf-image-title])]
       (when image
         [:img.verdict-image-preview.mb-3 {:src (files/file-link (:db/id group) (:db/id image) false)}])
       [upload/upload-button "form-pdf-header-image" {:attach-file-fn   (partial add-form-image (:db/id group))
                                                      :button-i18n-key  :file/upload-new-image
                                                      :accept-types     ["image/*"]
                                                      :size-constraints {:bytes (file-model/size-limits :file.category/form-image)}}]]
      (when group
        [form-header-text tr group])]]))
